var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconExercises = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ico-exercise",
    width: 12.627,
    height: 20.22,
    viewBox: "0 0 12.627 20.22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ico-exercise .a{fill:#e4eaf2;}.ico-exercise .b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.627,
    height: 20.22
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.672,20.22a2.013,2.013,0,0,1,0-4.026,2.013,2.013,0,1,1,0,4.026m0-3.225A1.212,1.212,0,1,0,6.9,18.221a1.228,1.228,0,0,0-1.227-1.227M7.31,15.446H4.1v-.923c-.034-3.052,1.683-4.5,3.063-5.663,1.07-.9,1.993-1.68,1.993-3a2.8,2.8,0,0,0-3-2.767c-1.645,0-2.709.915-2.709,2.331,0,.128,0,.234,0,.328,0,.135,0,.242,0,.347l.024.423H0V5.34C0,2.146,2.473,0,6.154,0c3.812,0,6.473,2.351,6.473,5.718,0,2.41-1.533,3.754-2.886,4.939-1.251,1.1-2.432,2.131-2.432,3.895Zm-2.412-.8H6.509v-.094c0-2.127,1.375-3.332,2.7-4.5s2.613-2.289,2.613-4.336C11.826,2.777,9.547.8,6.154.8,2.9.8.8,2.583.8,5.34v.384h1.84c0-.086,0-.182,0-.3C2.644,3.583,4.087,2.3,6.154,2.3a3.568,3.568,0,0,1,3.8,3.568c0,1.688-1.107,2.621-2.278,3.608C6.3,10.635,4.868,11.839,4.9,14.518Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconExercises, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_exercises.644ca8c9.svg";
export { ForwardRef as ReactComponent };